import * as React from 'react';
import {Breadcrumb, Responsive} from 'semantic-ui-react';
import i18n from '../../../../locale/i18n';
import {NavLink, RouteComponentProps, withRouter} from 'react-router-dom';
import {
  ColumnSortableComponentProps,
  InfinityScrollComponentProps,
  withColumnSort,
  withInfinityScrollHandlers, withPrintAndExport
} from '../../components/DataTable/dataService';
import {DataTable} from '../../components/DataTable/DataTable';
import LoadingSpinner from '../../containers/LoadingContainer/LoadingSpinner';
import {ColumnDefinition} from '../../components/DataTable/common';
import ContentContainer from '../../containers/ContentContainer/ContentContainer';
import LoadingContainer from '../../containers/LoadingContainer/LoadingContainer';
import axios from 'axios';
import {SortSelectionButton} from "../../components/DataTable/SortModal";
import {DataList} from "../../components/DataTable/DataList";
import {ViewLoadingSpinner} from "../../components/ViewLoadingSpinner";
import {TranslationFunction} from "i18next";
import {getGroupType, GroupType} from "./common";
import {AnalyticsTracking} from "../../components/AnalyticsTracking/AnalyticsTracking";

const t = i18n.t.bind(i18n);

const COLUMNS: ColumnDefinition[] = [
  {
    fieldName: 'VerstGruppeText',
    labelTranslationKey: 'Offer.VSTGrp',
    required: true,
    headerColspan: '2'
  },
  {
    fieldName: 'none',
    labelTranslationKey: 'Offer.VSTGrpType',
    required: true,
    noHeader: true,
    cellRender: (_, row) => <GroupType articleType={row.ArtikelArt} ccGtZero={row.AnzahlCCGT0} />,
    printExportRender: (_, row) => `${getGroupType(row.ArtikelArt, row.AnzahlCCGT0, t)}`
  },
  {
    fieldName: 'gesamtWagen',
    labelTranslationKey: 'Offer.gesamtWagen',
    required: true,
    cellAlign: 'right',
    cellRender: (_, row, filter) => {
      return (row.gesamtWagen);
    },
    printExportRender: (_, row) => (row.AnzahlCCGT0 > 0 ?  row.gesamtWagen :  row.anzWagenNr)
  }
];

const getScrollParent = () => ContentContainer.instance.componentRef.current;

const PageComponent = (props: RouteComponentProps & InfinityScrollComponentProps & ColumnSortableComponentProps) => {
  if(props.loadingInitial) {
    return <LoadingContainer showLogo={false}/>;
  }
  return (
      <>
        <AnalyticsTracking page="offer_vrm_public" />
        <div className={"sticky-header"}>
          <div className={"ui container"}>
            <h3><Breadcrumb icon="right angle" sections={[
              {
                key: '1',
                as: NavLink,
                to: '/offers',
                content: `${t("Route.OffersGuest")}`, link: true
              }
            ]}/></h3>
            <p>{t("Common.Found$dDatasets", {count: props.totalItems})}</p> <br/>
            <Responsive maxWidth={960} style={{paddingBottom: '2em'}}>
              <SortSelectionButton
                fluid={true}
                availableColumns={COLUMNS}
                currentSortColumn={props.sortColumn}
                currentDirection={props.sortDirection}
                onSave={props.handleSortUpdate}/>
            </Responsive>
            <ViewLoadingSpinner active={props.loading} />
          </div>
        </div>

        <div className={"ui container responsivewrapper"}>
          <Responsive minWidth={961}>
            <DataTable
                columns={COLUMNS}
                data={props.data}
                page={props.page}
                totalPages={props.totalPages}
                sortDirection={props.sortDirection}
                sortColumn={props.sortColumn}
                getScrollParent={getScrollParent}
                loadMore={props.loadMore}
                handleSortChange={props.handleSortChange}
                loading={props.loading}
            />
          </Responsive>
          <Responsive maxWidth={960}>
            <DataList data={props.data}
                      page={props.page}
                      totalPages={props.totalPages}
                      getScrollParent={getScrollParent}
                      loadMore={props.loadMore}
                      columns={COLUMNS}
                      renderItem={renderMobileListItems}
            />
          </Responsive>
          <div style={{opacity: props.loadingMore ? '1.0' : '0.0'}}>
            <div style={{textAlign: 'center', height: '3em', marginTop: '1.5em'}}><LoadingSpinner/>
            </div>
          </div>
          <div style={{height: '2em'}}/>
        </div>
      </>
  )
};

const renderMobileListItems = (row: any, t: TranslationFunction) => {
  return <>
    <div>
      <div><strong>{row.VerstGruppeText}</strong></div>
      <div>{getGroupType(row.ArtikelArt, row.AnzahlCCGT0, t)}&nbsp;</div>
    </div>
    <div style={{textAlign: 'right', flexGrow: 1}}>
      <div style={{display: 'flex'}}>
        <div style={{textAlign: 'right', flexGrow: 1}}>{(row.AnzahlCCGT0 > 0 ?  row.gesamtWagen :  row.anzWagenNr)}&nbsp;</div>
      </div>
      <div style={{display: 'flex'}}>
        <div style={{textAlign: 'right', flexGrow: 1}}>{t('Offer.gesamtWagen')} </div>
      </div>
    </div>
  </>;
};

const dataService = {
  loadPage(page: number, sortColumn: string, sortOrder: 'ASC' | 'DESC', filter: { [p: string]: any }): Promise<any> {
    // TODO replace with RestClient because of error handling, but currently alwas calls /api/ prefix
    return axios.get('public/todays-offer',{params: {
      sortBy: sortColumn,
      sortDirection: sortOrder,
      page: page,
      count: 50
    }});
  }
};

const PageComponentWrapped = withRouter(withColumnSort((withPrintAndExport(withInfinityScrollHandlers(PageComponent)))));

export default () => (
    <PageComponentWrapped
        dataService={dataService}
        defaultSortDirection="ASC"
        defaultSortColumn="VerstGruppeText"
        printColumns={COLUMNS}
        printPath={[
          `${t("Route.OffersGuest")}`
        ]}
    />
);
